import { render, staticRenderFns } from "./issues-status-rq.vue?vue&type=template&id=77d9d156&scoped=true"
import script from "./issues-status-rq.vue?vue&type=script&lang=js"
export * from "./issues-status-rq.vue?vue&type=script&lang=js"
import style0 from "./issues-status-rq.vue?vue&type=style&index=0&id=77d9d156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d9d156",
  null
  
)

export default component.exports